import { useCallback } from 'react';
import {
  useMarketplaceModal,
  UseMarketplaceModalProps,
} from './useMarketplaceModal';

export type UseMarketplaceListingModalProps = Omit<
  UseMarketplaceModalProps,
  'modalType' | 'title'
>;

export function useMarketplaceListingModal(
  props: UseMarketplaceListingModalProps = {}
): { open: (listingSlug: string) => void; close: () => void } {
  const { open: baseOpen, close } = useMarketplaceModal({
    modalType: 'LISTING',
    ...props,
  });

  const open = useCallback(
    (listingSlug: string) => baseOpen({ listingSlug }),
    [baseOpen]
  );

  return { open, close };
}
